import React, { useEffect, useState } from 'react'
import { apiClient } from '@/api/client'

interface Team { id: number; name: string }

interface Props {
  isOpen: boolean
  onClose: () => void
  onSelect: (team: Team) => void
}

const TeamSelectModal: React.FC<Props> = ({ isOpen, onClose, onSelect }) => {
  const [search, setSearch] = useState('')
  const [items, setItems] = useState<Team[]>([])
  const [loading, setLoading] = useState(false)

  const load = async () => {
    setLoading(true)
    try {
      const res = await apiClient.get('/api/v1/admin/teams')
      const list: Team[] = (res.data?.teams || res.data || []).map((t:any)=> ({ id: t.id, name: t.name }))
      setItems(list)
    } catch { setItems([]) } finally { setLoading(false) }
  }

  useEffect(()=> { if (isOpen) load() }, [isOpen])

  if (!isOpen) return null

  const filtered = items.filter(t => t.name.toLowerCase().includes(search.toLowerCase()) || String(t.id).includes(search))

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full max-w-xl rounded-xl shadow-xl border border-gray-200">
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="text-lg font-semibold">Takım Seç</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">✕</button>
        </div>
        <div className="p-4 space-y-4">
          <input value={search} onChange={(e)=>setSearch(e.target.value)} placeholder="Takım ara (ad veya ID)" className="w-full px-3 py-2 border rounded-md"/>
          <div className="max-h-80 overflow-auto divide-y">
            {loading ? <div className="p-4 text-gray-500">Yükleniyor...</div> : (
              filtered.length === 0 ? <div className="p-4 text-gray-500">Kayıt yok</div> : (
                filtered.map(t => (
                  <div key={t.id} className="p-3 flex items-center justify-between hover:bg-gray-50">
                    <div>
                      <p className="font-medium text-gray-900">{t.name}</p>
                      <p className="text-xs text-gray-500">ID: {t.id}</p>
                    </div>
                    <button className="px-3 py-1 border rounded-md hover:bg-gray-100" onClick={()=> onSelect(t)}>Seç</button>
                  </div>
                ))
              )
            )}
          </div>
          <div className="flex justify-end">
            <button onClick={onClose} className="px-3 py-2 border rounded-md">Kapat</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamSelectModal 